import { render, staticRenderFns } from "./KelaBatchTable.vue?vue&type=template&id=211784d2&scoped=true&"
import script from "./KelaBatchTable.vue?vue&type=script&lang=js&"
export * from "./KelaBatchTable.vue?vue&type=script&lang=js&"
import style0 from "./KelaBatchTable.vue?vue&type=style&index=0&id=211784d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211784d2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardTitle,VChip,VDataTable,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211784d2')) {
      api.createRecord('211784d2', component.options)
    } else {
      api.reload('211784d2', component.options)
    }
    module.hot.accept("./KelaBatchTable.vue?vue&type=template&id=211784d2&scoped=true&", function () {
      api.rerender('211784d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KelaBatch/KelaBatchTable.vue"
export default component.exports